import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import LinkPage from '@/pages/LinkPage';

// The link code travels in the #fragment (never sent to a server); `oauth=1` marks the
// return from a Google / Microsoft / Facebook sign-in started on this page.
const searchSchema = z.object({
  oauth: z.string().optional(),
});

export const Route = createFileRoute('/verify')({
  component: VerifyRoute,
  validateSearch: searchSchema,
});

function VerifyRoute() {
  const { oauth } = Route.useSearch();
  return <LinkPage oauthReturn={oauth === '1'} />;
}
